import React from 'react'
import Table from 'react-bootstrap/Table';
import Tooltip from 'react-bootstrap/Tooltip';
import * as AiIcons from "react-icons/ai";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import { Button, Container, FormControl, FormLabel, Row, Col } from 'react-bootstrap';
import UpdateUser from './UpdateUser';

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'8%'}}>User ID</th>
        <th style={{width:'50%'}}>User Name</th>
        <th className='d-none d-sm-table-cell' style={{width:'40%'}}>Email</th>
        <th style={{width:'5%'}}>{props.mode==0?'Edit':''}</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {
  if (props.usersObj) {
    const rows = props.usersObj.map((row, index) => { 
      return (      
        <tr key={index}>        
          <td>
            {row.id}
          </td>
          <td>  
            {row.username}
          </td>
          <td className='d-none d-sm-table-cell'>  
            {row.email}
          </td>         

          <td align='center'>  
            {(props.mode==0) &&
              <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={renderEditTooltip}>        
                <UpdateUser 
                  userid = {row.id}
                  username = {row.username}
                  email = {row.email}/>    
              </OverlayTrigger>              
            }
            {(props.mode==1) &&
              <Button onClick={() => {
                //console.log(row);
                props.onSelected(row.id,row.username,row.email);
                props.handleClose();
              }} variant='link' value={row.id}>Select</Button>
            } 
          </td>                    
        </tr>
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}

const renderEditTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    Click to edit the user.
  </Tooltip>
);



const UsersList = (props) => {        
  
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline", marginLeft:"13px",width:"99%"}} striped bordered hover size="sm">
            <TableHeader mode={props.mode} />
            <TableBody handleClose={props.handleClose} onSelected={props.onSelected} mode={props.mode} usersObj={props.listOfUsers} />
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
}

export default UsersList;